import { render, staticRenderFns } from "./HeaderLanguageDropdown.vue?vue&type=template&id=c6067c18&"
import script from "./HeaderLanguageDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderLanguageDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLanguageDropdown.vue?vue&type=style&index=0&id=c6067c18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports